import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=5d2b668e"
import script from "./updateDialog.vue?vue&type=script&lang=js"
export * from "./updateDialog.vue?vue&type=script&lang=js"
import style0 from "./updateDialog.vue?vue&type=style&index=0&id=5d2b668e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports